const paths = {
  root: '/',
  authenticated: {
    home: '/home',
    billOfLading: '/bill-of-lading/$billOfLadingId',
    customers: '/customers',
    portals: '/portals',
    portal: '/portals/$portalId',
    customerProductMatches: '/customer-product-matches',
    discounts: '/discounts',
    // purchaseOrders: '/purchase-orders',
    inventory: {
      products: '/inventory/products',
      product: '/inventory/products/$productId',
    },
    salesOrders: '/sales-orders',
    salesOrder: '/sales-orders/$salesOrderId',
    salesOrderDraft: '/sales-orders/draft/$draftId',
    salesOrderDraftExtractionViewer:
      '/sales-order-drafts/$draftId/extraction-viewer',
    invoiceDiff: '/invoices/$invoiceId1/$invoiceId2',
    accountsPayable: {
      invoices: '/accounts-payable/invoices',
      invoice: '/accounts-payable/invoices/$invoiceId',
      purchaseOrders: '/accounts-payable/purchase-orders',
      purchaseOrder: '/accounts-payable/purchase-orders/$purchaseOrderId',
      payments: '/accounts-payable/payments',
      payment: '/accounts-payable/payments/$paymentId',
    },
    accountsReceivable: {
      overview: '/ar/overview',
      invoices: '/ar/invoices',
      invoice: '/ar/invoices/$invoiceId',
      collections: '/ar/collections',
      agingReport: '/ar/aging-report',
      reconciliation: '/ar/reconciliation',
      customerCollections: '/ar/collections/$customerId',
    },
    rebates: {
      submitted: '/rebates/submitted',
      analytics: '/rebates/analytics',
      debitors: '/rebates/debtors',
      reporting: '/rebates/reporting',
      reconciliation: '/rebates/reconciliation',
      supplierCollections: '/rebates/supplier-collections/$supplierId',
      contracts: '/rebates/contracts',
      agreements: '/rebates/agreements',
      agreement: '/rebates/agreements/:id',
      calculationAudit: '/rebates/agreements/$agreementId/audit',
      uploadData: '/rebates/upload-data',
      uploadDataAI: '/rebates/upload-data/ai',
      uploadDataManual: '/rebates/upload-data/manual',
      uploadDataEmailQueue: '/rebates/upload-data/email-queue',
      uploadDataDemoResults: '/rebates/upload-data/demo-results/$uploadId',
      convertWorkflow: '/rebates/convert',
      enableConvert: '/rebates/enable-convert',
      tierProximity: '/rebates/tier-proximity',
      reports: '/rebates/reports',
      divisionRebateSummary: '/rebates/reports/division-summary',
      supplierTagSummary: '/rebates/reports/supplier-tag-summary',
      dailyEarningsPYE: '/rebates/reports/daily-earnings-pye',
      monthlyTrending: '/rebates/reports/monthly-trending',
      supplierPaymentTerms: '/rebates/reports/supplier-payment-terms',
      profitability: '/rebates/reports/profitability',
      dataExport: '/rebates/data-export',
      supplierReportedAmounts: '/rebates/supplier-reported-amounts/$supplierId',
    },
    shipping: '/shipping',
    shipAndDebit: {
      dashboard: '/ship-and-debit',
      vdm: '/ship-and-debit/vdm',
      transactions: '/ship-and-debit/844-and-849',
    },
    procurement: {
      suppliers: '/suppliers',
      supplier: '/supplier/$supplierId',
      inquiries: '/inquiries',
      inquiry: '/inquiries/$inquiryId',
      purchaseOrders: '/procurement/purchase-orders',
      purchaseOrder: '/procurement/purchase-order/$purchaseOrderId',
      priceSheetDashboard: '/price-sheet-dashboard',
      priceSheetInbox: '/price-sheet-inbox',
    },
    companies: '/companies',
    company: '/companies/$companyId',
    finance: {
      accounts: '/finance/accounts',
      balanceSheet: '/finance/balance-sheet',
      incomeStatement: '/finance/income-statement',
      ledgerRules: '/finance/ledger-rules',
    },
    businessIntelligence: '/business-intelligence',
    emailPOMetrics: '/email-po-metrics',
    reports: '/reports',
    workflows: {
      list: '/workflows',
      templates: '/workflows/templates',
      create: '/workflows/new',
      definition: '/workflows/$workflowDefinitionId',
    },
    agents: {
      list: '/agents',
      create: '/agents/new',
      detail: '/agents/$agentId',
    },
    settings: {
      organization: '/settings/organization',
    },
    inboundEmails: '/inbound-emails',
    // temp/demo links:
    spreadsheets: { new: '/spreadsheets/new' },
    traceability: '/traceability',
    traceabilityV2: '/traceability-v2',
    warehouses: '/warehouses',
    customerCollections: '/customer-collections/$customerId',
    documents: '/documents',
    document: '/documents/$documentId',
    famousEDI: '/famous-edi',
    famousEDIShipments: '/famous-edi-shipments',
    famousEDIShipment: '/famous-edi-shipments/$shipmentId',
    divisions: '/divisions',
    division: '/divisions/$divisionId',
    featureFlags: '/ff_overrides',
    procurementDemo: {
      dashboard: '/procurement-demo',
      aiWorkflows: '/procurement-demo/ai-workflows',
      aiWorkflowDetails: '/procurement-demo/ai-workflows/$agentId',
      procurementPlan: '/procurement-demo/procurement-plan',
      suppliers: '/procurement-demo/suppliers',
      items: '/procurement-demo/items',
      purchaseOrders: '/procurement-demo/purchase-orders',
      spendingAnalytics: '/procurement-demo/spending-analytics',
      inventory: '/procurement-demo/inventory',
    },
    allocations: '/allocations',
    historicalImport: '/admin/historical-import',
    rexelMonitoring: '/rexel-monitoring',
    memoryBankNotes: '/memory-bank-notes',
    sharedLinks: '/shared-links',
    integrations: {
      list: '/integrations',
      detail: '/integrations/$integrationKey',
    },
  },
  unauthenticated: {
    status: '/status',
  },
} as const;

export default paths;
